import { render } from "./pageTop.vue?vue&type=template&id=0c67e9b5&scoped=true"
import script from "./pageTop.vue?vue&type=script&lang=js"
export * from "./pageTop.vue?vue&type=script&lang=js"

import "./pageTop.vue?vue&type=style&index=0&id=0c67e9b5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c67e9b5"

export default script